function notNull(value) {
  return value !== null;
}

exports.notNull = notNull;